import React from 'react'
import Fields from 'components/common/Fields'
import getSelectedPostedBy from 'components/common/getSelectedPostedBy'

const genderMap = {
  Daughter: 'Female',
  Son: 'Male',
  Sister: 'Female',
}

const getGenderFromFields = (gender, postedby) => {
  if (gender === undefined || gender === '') {
    return genderMap[postedby]
  }
  return gender
}

export const GenderContext = props => {
  return (
    <Fields names={['gender', 'postedby']}>
      {({ gender, postedby }) => {
        let selectedPostedBy = getSelectedPostedBy(postedby.input.value)
        let chosenGender = getGenderFromFields(
          gender.input.value,
          selectedPostedBy
        )
        return props.children({
          gender: chosenGender,
          postedby: selectedPostedBy,
        })
      }}
    </Fields>
  )
}
